<template>
  <sdPageHeader :title="$t('pages.domains.title')"></sdPageHeader>
  <Main>
    <Table :config='{search: true, delete: true, edit: true, editType: "modal"}' :endpoints='$endpoints.domain' :columns='columns'>
    </Table>
  </Main>
</template>

<script>

import { Main } from '@/view/styled';
import Table from '@/components/tables/Default.vue';

export default {
  name: 'list',
  components: {
    Main,
    Table
  },
  data() {
    return {
      data: {},
      columns: [
        {
          title: this.$t('pages.domains.id'),
          dataIndex: 'id',
          sorter: true,
          width: '150px',
          search: true
        },
        {
          title: this.$t('pages.domains.domain'),
          dataIndex: 'domain',
          sorter: true,
          search: true,
          editable: true
        },
        {
          title: this.$t('common.action'),
          dataIndex: 'action',
          sorter: false,
          slots: {
            customRender: 'action'
          }
        }
      ]
    };
  },
};
</script>

<style scoped>

</style>